import { observer } from "mobx-react";
import { NoAccountantForm } from "./noAccountantDomain";
import { Alert } from "@/components-v2/Alert";
import { VBox } from "@/components-v2/Box";
import { formatOrgNum } from "@/utils/other";

import { useTranslation } from "@/stores/RootStoreContext";

export const NoAccountantFormView = observer(function NoAccountantFormView({
  form,
}: {
  form: NoAccountantForm;
}) {
  const { t } = useTranslation();
  const currentAccountant = form.data?.previousAccountant ?? form.previousAccountant;
  const orgNoPrefix = t("decisions.accountant.orgNoPrefix");
  return form.hasAccountant ? (
    <VBox gap={"md"}>
      {currentAccountant && (
        <div>
          <div>{t("decisions.accountant.company-accountant-now")}</div>
          {`${currentAccountant.name} (${orgNoPrefix} ${formatOrgNum(
            currentAccountant.organisationNumber,
          )})`}
        </div>
      )}
    </VBox>
  ) : (
    <div>
      <Alert message={t("decisionType.noAccountant.companyHasNoAccountant")} type={"warning"} />
    </div>
  );
});
